/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { gql } from '@apollo/client';

const findBlogs = () => (
    gql`
        query BlogsQuery($blogOptions: BlogOptions, $contentType: String!, $environment: String!) {
            findBlogs(contentType: $contentType, environment: $environment,blogOptions: $blogOptions){
                blogs{
                    uid
                    title
                    excerpt
                    image
                    contentType
                    dateModified
                    datePublished
                    url
                }
                total
                pages
            }
        }
    `
);

export default findBlogs;
